import { render, staticRenderFns } from "./FirstTimeRegistration.vue?vue&type=template&id=4034c474&scoped=true&"
import script from "./FirstTimeRegistration.vue?vue&type=script&lang=js&"
export * from "./FirstTimeRegistration.vue?vue&type=script&lang=js&"
import style0 from "./FirstTimeRegistration.vue?vue&type=style&index=0&id=4034c474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4034c474",
  null
  
)

export default component.exports